import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { CheckCircle, Zap } from 'lucide-react';

interface MentorTierSelectorProps {
  onTierSelected: (tier: 'free' | 'pro') => void;
  mentorName: string;
}

export const MentorTierSelector = ({ onTierSelected, mentorName }: MentorTierSelectorProps) => {
  const handleFreeTierSelect = () => {
    onTierSelected('free');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-background via-background/95 to-primary/5 flex items-center justify-center p-4">
      <div className="max-w-2xl w-full space-y-8">
        <div className="text-center space-y-4">
          <h1 className="text-3xl font-bold">Welcome to Ascendry, {mentorName}! 🎉</h1>
          <p className="text-lg text-muted-foreground">
            Your application has been approved. Let's get you started!
          </p>
        </div>

        <div className="flex justify-center">
          {/* Free Tier - Now the only option */}
          <Card className="relative max-w-md w-full">
            <CardHeader>
              <div className="flex items-center justify-between">
                <CardTitle className="flex items-center gap-2">
                  <Zap className="h-5 w-5 text-primary" />
                  Mentor Plan
                </CardTitle>
                <Badge variant="secondary">7.5% Platform Fee</Badge>
              </div>
              <CardDescription>
                Everything you need to start mentoring successfully
              </CardDescription>
            </CardHeader>
            <CardContent className="space-y-4">
              <div className="text-2xl font-bold">$0<span className="text-sm text-muted-foreground">/month</span></div>
              
              <ul className="space-y-2">
                <li className="flex items-center gap-2">
                  <CheckCircle className="h-4 w-4 text-mentor-primary" />
                  <span>Unlimited mentoring sessions</span>
                </li>
                <li className="flex items-center gap-2">
                  <CheckCircle className="h-4 w-4 text-mentor-primary" />
                  <span>Dashboard analytics</span>
                </li>
                <li className="flex items-center gap-2">
                  <CheckCircle className="h-4 w-4 text-mentor-primary" />
                  <span>Directory listing</span>
                </li>
                <li className="flex items-center gap-2">
                  <CheckCircle className="h-4 w-4 text-mentor-primary" />
                  <span>Platform flexibility</span>
                </li>
                <li className="flex items-center gap-2">
                  <CheckCircle className="h-4 w-4 text-mentor-primary" />
                  <span>Student booking system</span>
                </li>
                <li className="flex items-center gap-2">
                  <CheckCircle className="h-4 w-4 text-mentor-primary" />
                  <span>Payment processing</span>
                </li>
              </ul>

              <div className="pt-4 border-t">
                <p className="text-sm text-muted-foreground">
                  <strong>Platform Fee:</strong> 7.5% deducted from each session payout
                </p>
              </div>

              <Button 
                onClick={handleFreeTierSelect}
                className="w-full"
                size="lg"
              >
                Get Started Now
              </Button>
            </CardContent>
          </Card>
        </div>

        <div className="text-center text-sm text-muted-foreground">
          <p>Start mentoring immediately - no monthly fees, no commitments!</p>
        </div>
      </div>
    </div>
  );
};